import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/pages/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import Fairs from "@/pages/Fairs";
import News from "@/pages/News";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Catalog from "@/pages/Catalog";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/fairs" element={<Fairs />} />
            <Route path="/news" element={<News />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/catalog" element={<Catalog />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </AppProvider>
  );
}

export default App;
